import { eq } from "drizzle-orm";
import { Link as MuiLink, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

import { db } from "@/db/db";
import { file } from "@/db/schema";
import type { Item } from "@/db/types";
import { useReactiveRelationalQuery } from "@/models/hooks/useReactiveRelationalQuery";

const filesQuery = (contentId: string) =>
  db.query.file.findMany({
    where: eq(file.contentId, contentId),
  });

export default function ItemFilesTable({ item }: { item: Item }) {
  const files = useReactiveRelationalQuery(filesQuery, [item.contentId], "ItemFilesTable:findManyFiles") ?? [];

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Type</TableCell>
            <TableCell sx={{ fontFamily: "monospace", fontSize: "0.75rem" }}>ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {files.map((row) => (
            <TableRow key={row.id} sx={{ "&:last-child td": { border: 0 } }}>
              <TableCell>
                <MuiLink href={row.url} target="_blank" rel="noreferrer">
                  {row.name}
                </MuiLink>
              </TableCell>
              <TableCell>{row.mimeType}</TableCell>
              <TableCell sx={{ fontFamily: "monospace", fontSize: "0.75rem" }}>{row.id}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
